// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__1Hwdu","cell":"TableRow_cell__7nNuL"};